<section class="static-text-section static-text-section--pad mx-auto flex w-full flex-col py-10">
  <div
    class="static-text-inner flex w-full flex-col gap-8 rounded-2xl border p-6 shadow-[var(--shadow-card)]"
  >
    <div class="static-text-media shrink-0 overflow-hidden rounded-xl">
      <img
        [src]="staticImagePath"
        alt="Healthcare professionals collaborating with data and analytics"
        class="static-text-image h-full w-full object-cover"
        loading="lazy"
      />
    </div>

    <div class="static-text-content flex min-w-0 flex-1 flex-col gap-10">
      <div class="static-text-intro flex flex-col gap-5 text-left">
        <span class="static-text-badge inline-flex w-fit items-center gap-2 self-center rounded-full px-3.5 py-2 text-sm font-semibold">
          <img [src]="badgeIconPath" alt="" aria-hidden="true" class="static-text-badge-icon object-contain" />
          About IUDX Healthcare
        </span>

        <h2 class="static-text-title font-bold leading-tight">
          A trusted healthcare exchange built for secure discovery, reuse and innovation
        </h2>

        <p class="static-text-body leading-relaxed">
          IUDX Healthcare brings datasets, models, use cases and collaboration pathways into one
          professional platform for the healthcare ecosystem. It helps institutions, researchers and
          innovators discover assets faster while supporting governed access and responsible reuse.
        </p>
      </div>

      <div class="static-text-features">
        @for (feature of features; track feature.title) {
          <article class="static-text-feature-card">
            <div class="static-text-feature-icon-wrap" aria-hidden="true">
              <img [src]="feature.iconPath" alt="" class="static-text-feature-icon object-contain" />
            </div>
            <h3 class="static-text-feature-title leading-snug">
              {{ feature.title }}
            </h3>
            <p class="static-text-feature-desc leading-relaxed">
              {{ feature.description }}
            </p>
          </article>
        }
      </div>
    </div>
  </div>
</section>
